// Route mapping between Dutch (default) and English (/en/...) URLs.
export const ROUTE_MAP = {
  home:      { nl: '/',                   en: '/en' },
  diensten:  { nl: '/diensten',           en: '/en/services' },
  service:   { nl: '/diensten/:slug',     en: '/en/services/:slug' },
  portfolio: { nl: '/portfolio',          en: '/en/projects' },
  prijzen:   { nl: '/prijzenlijst',       en: '/en/pricing' },
  mobile:    { nl: '/detailing-aan-huis', en: '/en/mobile-detailing' },
  over:      { nl: '/over',               en: '/en/about' },
  reviews:   { nl: '/reviews',            en: '/en/reviews' },
  contact:   { nl: '/contact',            en: '/en/contact' },
  apeldoorn: { nl: '/detailing-apeldoorn', en: '/en/detailing-apeldoorn' },
  zutphen:   { nl: '/detailing-zutphen',   en: '/en/detailing-zutphen' },
  raalte:    { nl: '/detailing-raalte',    en: '/en/detailing-raalte' },
};

export const resolvePath = (lang, key, params = {}) => {
  let p = (ROUTE_MAP[key] && ROUTE_MAP[key][lang]) || '/';
  Object.entries(params).forEach(([k, v]) => { p = p.replace(`:${k}`, v); });
  return p;
};

const stripTrailing = (p) => (p.length > 1 && p.endsWith('/') ? p.slice(0, -1) : p);

export const matchRoute = (pathname) => {
  const path = stripTrailing(pathname);
  for (const [key, m] of Object.entries(ROUTE_MAP)) {
    for (const lang of ['en', 'nl']) {
      const pattern = m[lang];
      if (pattern.includes(':')) {
        const re = new RegExp('^' + pattern.replace(/:[^/]+/g, '([^/]+)') + '$');
        const match = path.match(re);
        if (match) return { key, lang, params: { slug: match[1] } };
      } else if (pattern === path) {
        return { key, lang, params: {} };
      }
    }
  }
  return null;
};

export const switchLangPath = (pathname, targetLang) => {
  const m = matchRoute(pathname);
  if (!m) return targetLang === 'en' ? '/en' : '/';
  return resolvePath(targetLang, m.key, m.params);
};

export const langFromPath = (pathname) =>
  pathname === '/en' || pathname.startsWith('/en/') ? 'en' : 'nl';
